import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "api";
import { ShareResponse } from "type";

export const sharesApi = createApi({
  reducerPath: "sharesApi",
  baseQuery: axiosBaseQuery({
    baseUrl: "/v1/shares",
  }),
  endpoints: (builder) => ({
    getShare: builder.query<ShareResponse, string>({
      query: (shareId) => ({
        url: `/${shareId}`,
        method: "get",
      }),
    }),
  }),
});

export const { useGetShareQuery } = sharesApi;
